import { render } from "./Footer.vue?vue&type=template&id=007d3bd5&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=007d3bd5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007d3bd5"]])

export default __exports__